import { CartsDocument, useResetStuckCartMutation } from "../../Generated/graphql";
import "./CartFailedBanner.css";

type CartFailedBannerProps = {
  cartId: string;
};

export const CartFailedBanner = ({ cartId }: CartFailedBannerProps) => {
  const [resetCart, { loading }] = useResetStuckCartMutation({
    refetchQueries: [{ query: CartsDocument }],
    awaitRefetchQueries: true,
  });

  const handleReset = () => {
    resetCart({ variables: { cartId } });
  };

  return (
    <div className="CartFailedBanner" role="alert">
      <div className="CartFailedBanner__icon">⚠️</div>
      <div className="CartFailedBanner__content">
        <div className="CartFailedBanner__title">
          Din automatiske bestilling kunne ikke gennemføres
        </div>
        <div className="CartFailedBanner__description">
          Der opstod en fejl ved afsendelse af din ordre. Kontakt kundeservice
          hvis problemet fortsætter.
        </div>
      </div>
      <button
        className="CartFailedBanner__button"
        onClick={handleReset}
        disabled={loading}
      >
        {loading ? "Nulstiller..." : "Prøv igen"}
      </button>
    </div>
  );
};
